var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TRANSLATION_CONTEXT } from './componentConfig';
import DocumentTypes from './DocumentTypes';
import { withTranslator } from '@wh/ui-translations';
function DocumentTypeContainer(props) {
    var translate = function (msg) { return props.t(TRANSLATION_CONTEXT)(msg); };
    var propsWithTranslator = __assign(__assign({}, props), { t: translate });
    return React.createElement(DocumentTypes, __assign({}, propsWithTranslator));
}
export default withTranslator(DocumentTypeContainer);
//# sourceMappingURL=DocumentTypesContainer.js.map